
import React from 'react';
import { format } from 'date-fns';
import { Interview } from '@/types/interview';
import { TableCell, TableRow } from '@/components/ui/table';
import TableActionButtons from './TableActionButtons';
import FolderAssignMenu from './FolderAssignMenu';
import { InterviewFolder } from '@/hooks/interview/useInterviewFolders';

interface InterviewTableRowProps {
  interview: Interview;
  onViewInterview: (interview: Interview) => void;
  onEditInterview: (interview: Interview) => void;
  onPublish: (interviewId: string) => void;
  onSendToFeeder: (interviewId: string) => void;
  onDelete: (interviewId: string) => void;
  publishingId: string | null;
  sendingToFeederId: string | null;
  deletingId: string | null;
  folders?: InterviewFolder[];
  assignedFolderIds?: string[];
  onToggleFolder?: (interviewId: string, folderId: string, isAssigned: boolean) => void;
}

const InterviewTableRow: React.FC<InterviewTableRowProps> = ({
  interview,
  onViewInterview,
  onEditInterview,
  onPublish,
  onSendToFeeder,
  onDelete,
  publishingId,
  sendingToFeederId,
  deletingId,
  folders = [],
  assignedFolderIds = [],
  onToggleFolder,
}) => {
  return (
    <TableRow key={interview.id}>
      <TableCell className="font-medium">{interview.intervieweeName}</TableCell>
      <TableCell>
        {format(new Date(interview.timestamp), 'MMM d, yyyy - h:mm a')}
      </TableCell>
      <TableCell>
        <div className="flex items-center gap-1">
          <TableActionButtons
            interview={interview}
            onViewInterview={onViewInterview}
            onEditInterview={onEditInterview}
            onPublish={onPublish}
            onSendToFeeder={onSendToFeeder}
            onDelete={onDelete}
            publishingId={publishingId}
            sendingToFeederId={sendingToFeederId}
            deletingId={deletingId}
          />
          {folders.length > 0 && onToggleFolder && (
            <FolderAssignMenu
              folders={folders}
              assignedFolderIds={assignedFolderIds}
              onToggleFolder={(folderId, isAssigned) => onToggleFolder(interview.id, folderId, isAssigned)}
            />
          )}
        </div>
      </TableCell>
    </TableRow>
  );
};

export default InterviewTableRow;
